// Generated by writeVersion.ts at build time. See committed placeholder file.
export const VERSION = '1.0' as string;
export const BUILD_NUMBER = '066' as string;
